document.addEventListener("alpine:init", () => {
    Alpine.data("scrollSwitcherTriggerItem", () => ({
        id: null,

        init() {},
    }));
});
